import { Event } from "react-big-calendar";
import { CalendarEventModel, NewCalendarEventModel } from "services/api/cplapi/CPLAPI";

export class CPLCalendarEvent extends CalendarEventModel implements Event {}
export class NewCPLCalendarEvent extends NewCalendarEventModel implements Event {}
